import React from 'react';

import { Page } from 'src/ui/templates/page';
import { GroupsGrid } from 'src/ui/molecules/groups-grid';
import { CreateGroupButton } from 'src/features/home/ui/create-group-button';
import { fetchUserGroupsFx, groupFavoriteFx, userGroups$ } from 'src/store/groups-collection.store';

export const UserGroupsPage = () => {
	return (
		<Page>
			<GroupsGrid
				groups$={userGroups$}
				fetchGroupsFx={fetchUserGroupsFx}
				onFavorite={groupFavoriteFx}
			/>
			<CreateGroupButton/>
		</Page>
	);
};
